import { AlertTriangle } from 'lucide-react';

export function ErrorState({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div
      role="alert"
      className="flex flex-col items-start gap-3 rounded-card border border-destructive/40 bg-card p-6"
    >
      <p className="flex items-center gap-2 font-medium text-destructive">
        <AlertTriangle aria-hidden="true" className="size-5" />
        {message}
      </p>
      {onRetry !== undefined && (
        <button
          type="button"
          onClick={onRetry}
          className="min-h-11 cursor-pointer rounded-control border border-border px-4 font-medium hover:bg-muted"
        >
          Reintentar
        </button>
      )}
    </div>
  );
}
